import { FunctionComponent } from "react";
import { useFormContext } from "react-hook-form";
import { getError, getTranslationError } from "./utils";
import { StyledWarning } from "./warning.styles";
import { useTranslate } from "stores/hooks/translation";

interface ErrorProps {
  name: string;
  translations?: boolean;
}

const Warning: FunctionComponent<ErrorProps> = ({
  name,
  translations = false,
}) => {
  const translate = useTranslate();
  const context = useFormContext();
  const { errors: formStateErrors } = context.formState;

  if (translations) {
    // error in localeString kind of field
    const errors = getTranslationError(formStateErrors, name.split(".")[0]);
    if (errors) {
      return (
        <StyledWarning>
          {errors.map((err) => translate(err)).join(" ")}
        </StyledWarning>
      );
    }
  } else {
    // error in a normal field
    const error = getError(formStateErrors, name);
    if (error) {
      return <StyledWarning>{translate(error)}</StyledWarning>;
    }
  }

  // no errors at all
  return null;
};

export default Warning;
